module.exports = __webpack_public_path__ + "static/img/rl.17bcdac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/games/games_grey/rl.svg
// module id = fz8Y
// module chunks = 35